import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import {
  STANDALONE_FEATURES,
  openStandaloneFeature,
} from "../../utils/standaloneFeatures";

const STANDALONE_TAB_MAP = {
  "#profile-manage-team": STANDALONE_FEATURES.MANAGE_TEAMS,
  "#profile-manage-branches": STANDALONE_FEATURES.MANAGE_SITES,
};

const Navbar = ({ tab, setTab, isManager, branchID, isAdmin, isCompany, isCompanyAdmin, isFellowAdmin }) => {
  const [searchParams] = useSearchParams();
  const companyID = searchParams.get("companyID");
  const queryBranchID = searchParams.get("branchID");

  const resolvedBranchID = branchID || queryBranchID;
  const showManageTeams = !isAdmin;
  const showManageSites = !isAdmin && !isManager && !resolvedBranchID;

  const tabs = [
    { target: "#profile-overview", title: "Overview" },
    { target: "#profile-edit", title: "Edit Profile" },
    ...(isCompany || isAdmin ? [{ target: "#profile-report", title: "Report Settings" }] : []),
    { target: "#profile-manage-permissions", title: "Permissions" },
    ...(showManageTeams
      ? [{ target: "#profile-manage-team", title: "Manage Teams", standalone: true }]
      : []),
    ...(isAdmin
      ? []
      : [{ target: "#profile-manage-profileEmail", title: "Ticket Recipients" }]),
    ...(showManageSites
      ? [{ target: "#profile-manage-branches", title: "Manage Sites", standalone: true }]
      : []),
    { target: "#profile-support", title: "Support" },
  ];

  useEffect(() => {
    if (!tab) setTab(tabs[0].target);
  }, [tab]);

  const openStandaloneTab = (target) => {
    const feature = STANDALONE_TAB_MAP[target];
    if (!feature) return;

    openStandaloneFeature(feature.path, {
      returnUrl: window.location.href,
      companyID: companyID || localStorage.getItem("_id"),
      branchID: branchID || queryBranchID || undefined,
    });
  };

  return (
    <ul className="nav nav-tabs nav-tabs-bordered">
      {tabs?.map((item, index) => (
        <li key={index} className="nav-item">
          <button
            type="button"
            onClick={() => (item.standalone ? openStandaloneTab(item.target) : setTab(item.target))}
            className={"nav-link " + (!item.standalone && tab == item.target ? "active" : "")}
          >
            {item.title}
            {item.standalone ? (
              <i className="bi bi-box-arrow-up-right ms-1" style={{ fontSize: "0.75rem" }} />
            ) : null}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default Navbar;
